import { css } from 'lit';
export default css `
  :host([theme='synapse-light']) {
    --table-highlight-color: #f3eeff;
  }
  :host([theme='synapse-dark']) {
    --table-highlight-color: var(--synapse-color-neutral-3);
  }

  .container {
    position: relative;
    display: flex;
    max-height: var(--table-max-height, none);
    overflow-y: auto;
    transition: all 0.4s ease-out;
    border: 1px solid var(--border-color-default);
    border-radius: 4px;
  }

  @media only screen and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    .container {
      max-height: none;
    }
  }

  :host([loading]) ui5-table {
    opacity: 0.6;
    transition: 0.2s;
    transition-delay: 0.5s;
    pointer-events: none;
  }

  ui5-table {
    display: block;
    background-color: var(--table-body-bg-color, var(--surface-color-default));
    border-radius: 4px;
    border-collapse: separate;
    border-spacing: 0;
    border-style: hidden;
    --ui5_table_header_row_border_bottom_color: var(--border-color-default);
    --sapButton_TextColor: var(--table-text-color, var(--type-color-default));
    --sapList_Background: var(--table-body-bg-color, var(--surface-color-default));
    --sapFontFamily: var(--synapse-font-family-primary), Arial, Helvetica, sans-serif;
    --sapFontLightFamily: var(--synapse-font-family-primary), Arial, Helvetica, sans-serif;
    --sapFontBoldFamily: var(--synapse-font-family-primary), Arial, Helvetica, sans-serif;
    --sapFontBlackFamily: var(--synapse-font-family-primary), Arial, Helvetica, sans-serif;
    --sapFontHeaderFamily: var(--synapse-font-family-primary), Arial, Helvetica, sans-serif;
    --sapList_Hover_Background: var(--table-row-hover, var(--interactive-color-neutral-default));
    --_ui5_checkbox_checkmark_color: var(--table-column-selected, var(--interactive-color-brand-default));
    --_ui5_checkbox_inner_selected_border_color: var(--table-column-selected, var(--border-color-brand-default));
    --_ui5_checkbox_inner_border: 2px solid var(--border-color-default);
    --_ui5_checkbox_inner_border_radius: 4px;
    --_ui5_checkbox_focus_outline_display: none;
  }

  ui5-table[_no-data-displayed] {
    --sapTextColor: var(--type-color-secondary, var(--table-text-color));
  }

  ui5-table-group-row {
    line-height: 3em;
  }

  ui5-table.drillDownTable ui5-table-row::part(row) {
    cursor: pointer;
  }
  ui5-table-row::part(row) {
    vertical-align: middle;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 75vh;
    min-width: min-content;
    background-color: var(--table-body-bg-color, var(--surface-color-default));
    height: var(--table-row-height, 44px);
    border-top: 1px solid var(--border-color-default);
    border-bottom: 1px solid var(--border-color-default);
  }

  ui5-table-row:last-child::part(row) {
    border-bottom: unset;
  }

  ui5-table-row::part(popin-row) {
    --sapList_Background: var(--table-body-bg-color, var(--surface-color-default));
    --sapContent_LabelColor: var(--table-text-color, var(--type-color-default));
    font-weight: bold;
  }

  ui5-table-group-row::part(group-row) {
    --sapList_TableGroupHeaderBackground: var(--table-body-bg-color, var(--surface-color-default));
    --sapList_TableGroupHeaderTextColor: var(--table-text-color, var(--type-color-default));
  }

  ui5-table-cell {
    color: var(--table-text-color, var(--type-color-default));
    font-weight: normal;
    font-size: 12px;
    font-family: var(--synapse-font-family-primary);
  }

  :host(.limited-col-width) ui5-table-cell:not(.group-checkbox) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 0;
  }

  :host(.limited-col-width) ui5-table-cell[popined] {
    max-width: unset;
  }

  ui5-table-cell:not(:first-child) {
    justify-content: var(--table-cel-text-align, center);
    text-align: var(--table-cel-text-align, center);
  }

  ui5-table-column::part(column) {
    border: none;
    background: var(--table-header-bg-color, var(--surface-color-default));
    cursor: pointer;
    height: var(--table-header-height, 56px);
    color: var(--table-text-color, var(--synapse-color-neutral-7));
  }

  ui5-table-row.footer::part(row) {
    height: var(--table-footer-height, 56px);
    position: sticky;
    bottom: 0;
  }

  ui5-table-column::part(column):not(:first-child) .title-container {
    margin-left: 10px;
  }

  .sort-icon {
    --goto-icon-size: 16px;
    width: 20px;
    height: 16px;
    opacity: 0;
    transition: opacity 0.1s;
  }

  ui5-table-row::part(row):hover {
    background-color: var(--table-row-hover, var(--interactive-color-neutral-default));
  }

  ui5-table::part(cell) {
    color: var(--table-text-color, var(--type-color-default));
    font-size: 13px;
  }

  ui5-table-row.footer ui5-table-cell::part(cell) {
    font-weight: bold;
  }

  ui5-table-column::part(column) {
    font-weight: bold;
    font-size: 13px;
  }

  ui5-table-column.shrink::part(column) {
    padding: 0;
    width: 0;
  }

  ui5-table-column:first-child .header-container {
    justify-content: left;
  }

  ui5-table-column:first-child.center-header .header-container {
    justify-content: center;
    padding-left: 16px;
  }

  ui5-table-column .header-container {
    display: flex;
    align-items: center;
    justify-content: var(--tabel-header-justify-content, center);
    padding-bottom: 0;
    color: var(--table-text-color, --type-color-default);
  }

  .title-container {
    padding: 4px 6px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }

  ui5-table-column:hover > .title-container,
  ui5-table-column:hover > div > .title-container {
    color: var(--table-column-selected, var(--type-color-brand-default));
  }

  ui5-table-column:hover .sort-icon {
    opacity: 1;
  }

  ui5-table-column.sortedColumnHeader > .title-container,
  ui5-table-column.sortedColumnHeader > div > .title-container,
  ui5-table-column.selector:hover {
    color: var(--table-column-selected, var(--type-color-brand-default));
    background-color: var(--table-column-bg-selected, var(--surface-color-brand-secondary));
  }

  ui5-table-column.sortedColumnHeader .sort-icon {
    opacity: 1;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  synapse-spinner {
    position: absolute;
    z-index: 100;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-name: fadein;
    animation-duration: 0.7s;
    --spinnerColor: var(--table-loading-spinner-color, var(--synapse-color-primary-3));
  }

  @keyframes fadein {
    from {
      opacity: 0;
    }
    78% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  ui5-table-column.action::part(column) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .action > * {
    --goto-icon-color: var(--table-action-color, var(--synapse-color-neutral-5));
    color: var(--table-action-color, var(--synapse-color-neutral-5));
  }

  .action > *:hover {
    --goto-icon-color: var(--table-action-color-hovered, var(--synapse-color-primary-3));
    color: var(--table-action-color-hovered, var(--synapse-color-primary-3));
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--table-scrollbar-thumb, var(--synapse-color-primary-3));
  }
  ::-webkit-scrollbar-thumb:hover {
    background: var(--table-scrollbar-thumb-hovered, var(--synapse-color-primary-4));
  }
  ::-webkit-scrollbar-track {
    background: var(--table-scrollbar-track, transparent);
    box-shadow: inset 7px 10px 12px #f0f0f0;
  }

  :host(.limited-col-width) ui5-table-cell.row-actions {
    height: auto;
    position: relative;
    background-color: unset;
    overflow: unset;
  }

  .row-actions-container {
    position: absolute;
    right: 0;
    top: 0;
    visibility: hidden;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    max-width: 200px;
    height: calc(100% - 4px);
    padding-left: 10px;
    margin: 2px 0;
  }

  ui5-table-row:hover .row-actions-container,
  .row-actions:hover .row-actions-container {
    visibility: visible;
    background-color: var(--table-row-hover, var(--interactive-color-neutral-default));
  }

  synapse-drawer > div.drawer-body {
    height: 100%;
    outline: none;
    padding: 0 16px;
  }

  .icon-button {
    --goto-icon-size: 18px;
    width: 24px;
    height: 24px;
  }

  #columnSelector {
    --goto-icon-size: 30px;
    width: 30px;
    height: 30px;
  }

  div[growing-button] {
    background-color: red;
  }

  ui5-table-row.highlighted::part(row),
  ui5-table-row[selected]::part(row) {
    background-color: var(--table-highlight-color);
  }

  ui5-table-row.highlighted:hover .row-actions-container,
  ui5-table-row[selected] .row-actions-container,
  ui5-table-row[selected]:hover .row-actions-container,
  .row-actions .row-actions-container {
    background-color: var(--table-highlight-color);
  }

  ui5-table-row.disabled-row::part(row) {
    pointer-events: none;
    opacity: 50%;
  }
`;
